export const animationSettings = {
  'fs-end-port': {
    'default': ['static'],
    'STATE:IN:FS-END': ['play', false, 'popup-start-port', { name: 'LOOP-END-FS', delay: 2 }],
    'LOOP-END-FS': ['play', true, 'popup-loop-port'],
  },

  'fs-add': {
    'default': ['static'],
    'STATE:IN:FS-ADD': ['play', false, 'reels-break', { name: 'REELS-DONE', delay: 1.5 }],
    'REELS-DONE': ['play', false, 'fs-start-popup', { name: 'LIGHT-START', delay: 3 }],
    'LIGHT-START': ['play', false, 'white-light-start'],
  },

  'fs-start': {
    'default': ['static'],
    'STATE:IN:FS-START': ['play', true, 'white-light-loop'],
    'BUTTON:light': ['play', false, 'white-light-end', { name: 'BUTTON:startFreespin', delay: 2 }],
  },

  'people_pop_start_land': {
    'default': ['play', true, 'people-pop-loop-land'],
    'STATE:IN:FS-END': ['play', false, 'people-pop-start-land'],
    'LOOP-END-FS': ['play', true, 'people-pop-loop-land'],
  },

  'hands_01_pop_start_land': {
    'default': ['static'],
    'STATE:IN:FS-END': ['play', false, 'hands-01-pop-start-land'],
    'LOOP-END-FS': ['play', true, 'hands-01-pop-loop-land'],
  },

  'hands_02_pop_start_land': {
    'default': ['static'],
    'STATE:IN:FS-END': ['play', false, 'hands-02-pop-start-land'],
    'LOOP-END-FS': ['play', true, 'hands-02-pop-loop-land'],
  },

  'hands_03_pop_start_land': {
    'default': ['static'],
    'STATE:IN:FS-END': ['play', false, 'hands-03-pop-start-land'],
    'LOOP-END-FS': ['play', true, 'hands-03-pop-loop-land'],
  },
}
